import Vue from 'vue';
import Router from 'vue-router';
import GuestLayout from '../layout/GuestLayout.vue';
import ProjectsLayout from '../layout/ProjectsLayout.vue';
import TasksLayout from '../layout/TasksLayout.vue';
import TasksHome from '../pages/TasksHome.vue';
import TimesheetHome from '../pages/TimesheetHome.vue';
import TimelineHome from '../pages/TimelineHome.vue';
import Billing from '../pages/Billing.vue';
import LogScreen from '../pages/LogScreen.vue';
import TaskDetail from '../pages/TaskDetail.vue';
import Invite from '../pages/Invite.vue';



Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
   
    {
      path: '/landing',
      name: 'home',
      component: GuestLayout,
      // children: [
      //   {
      //     path: '',
      //     name: '',
      //     components: { default: Login }
      //   },
      //   {
      //     path: 'home',
      //     name: 'home',
      //     component:Login
      //   },
      //   {
      //     path: 'another',
      //     name: 'another',
      //     component:Another
      //   }
      // ]
    },
    {
      path: '/',
      name: 'projects',
      meta:{label: 'Projects', mobileLabel: 'Proj'},
      component: ProjectsLayout,
    },
    {
      path: '/invite',
      name: 'invite',
      component: Invite
    },
    {
      path: '/timesheet',
      meta:{label: 'Timesheet'},
      component: TasksLayout,
      children:[
        {
          path: '',
          meta:{label: 'Timesheet', mobileLabel: 'Tim', requiresAuth: true},
          name: 'timesheet.home',
          components: {default: TimesheetHome}
        }]
    },
    
    {
      path: '/user',
      name: 'user',
      component: TasksLayout,
      children:[
        {
          path: 'billing',
          name: 'billing.home',
          meta:{label: 'Billing', mobileLabel: 'Bill'},
          components: {default: Billing}
        },

        {
          path: 'log',
          name: 'billing.log',
          components: {default: LogScreen}
        }
      ]
    },
    {
      path: '/projects/:id',
      component: TasksLayout,
      children:[
        {
          path: '',
          name: 'tasks.home',
          meta:{label: 'Tasks', mobileLabel: 'Tasks', requiresAuth: true},
          components: {default: TasksHome}
        },
        {
          path: 'tasks',
          name: 'tasks',
          component: TasksHome 
        },
        {
          path: 'quote',
          name: 'tasks.quote',
          meta:{label: 'Tasks', mobileLabel: 'Tasks', requiresAuth: true},
          components: {default: TasksHome}
        },
        {
          path: 'timeline',
          name: 'timeline.home',
          component: TimelineHome ,
          meta:{label: 'Timeline', mobileLabel: 'Timeline', requiresAuth: true},
        },
        {
          path: 'tasks/:taskId',
          name: 'taskDetail',
          component: TaskDetail 
        }
      ]
    }
  ],
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }

});
